/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import { MWLTextBox } from 'react-web-white-label'

const DpsTextBox = ({
  label,
  size = 'small',
  placeholder = '',
  className,
  maxRows,
  maxLength,
  multiline = false,
  rows,
  type,
  fieldName,
  onchangeHandler,
  value,
  readOnly,
  condition,
  onFocus,
  disabled,
  error,
  errorText,
  startAdornmentIcon,
  ...rest
}) => {
  const textfieldChangeHandler = (event) => {
    const rawValue = event.target.value

    let processedValue =
      condition === 'customdecimal'
        ? (() => {
            let value = rawValue.replace(/[^0-9.]/g, '')
            value = value.replace(/(\..*)\./g, '$1') // allow only one decimal
            const [intPartRaw, decPartRaw = ''] = value.split('.')
            const intPart = intPartRaw.slice(0, 10)
            const decPart = decPartRaw.slice(0, 2)
            let result = intPart
            if (value.includes('.')) {
              result += '.' + decPart
            }

            if (result.length > 13) {
              result = result.slice(0, 13)
            }

            return result
          })()
        : condition === 'decimal'
        ? rawValue
            .replace(/[^0-9.]/g, '') // remove anything that's not a number or dot
            .replace(/^([^.]*\.)|\./g, '$1') // allow only one dot
            .replace(/^(\d*\.\d{0,2}).*$/, '$1') // allow only two digits after the dot
        : type === 'numeric'
        ? rawValue !== ''
          ? rawValue.replace(/[^0-9.]/g, '').replace(/^-/, '')
          : ''
        : type === 'alpha'
        ? rawValue.replace(/[^a-zA-Z ]/g, '')
        : type === 'alphaNumeric'
        ? rawValue.replace(/[^a-zA-Z0-9 ]/g, '')
        : condition === 'alphanumeric'
        ? rawValue.replace(/[^a-zA-Z0-9&,\-;+.\s]/g, '')
        : condition === 'sortcode'
        ? rawValue
            .replace(/[^0-9]/g, '')
            .replace(/(\d{2})(?=\d)/g, '$1-')
            .slice(0, 8)
        : condition === 'alphanumericrestrictonly'
        ? rawValue
            .replace(/[^a-zA-Z0-9]/g, '')
            .replace(/(\d{2})-(?=\d{2})/g, '$1')
        : rawValue

    if (
      condition !== 'customdecimal' &&
      maxLength &&
      processedValue.length > maxLength
    ) {
      processedValue = processedValue.toString().slice(0, maxLength)
    }
    const params = {
      event,
      id: fieldName,
      value: processedValue,
    }

    if (onchangeHandler) {
      onchangeHandler(event, params, rest, maxLength)
    }
  }
  const handleBlur = (e) => {
    if (condition === 'customdecimal') {
      let val = String(value ?? '')

      if (val && !val.includes('.')) {
        val += '.00'
      } else if (val.endsWith('.')) {
        val += '00'
      } else if (/\.\d$/.test(val)) {
        val += '0'
      }

      const [intPart, decPart = ''] = val.split('.')
      const processed =
        intPart.slice(0, 10) + (decPart ? '.' + decPart.slice(0, 2) : '')

      const params = {
        event: e,
        id: fieldName,
        value: processed,
      }

      onchangeHandler?.(e, params, rest, maxLength)
    }
  }
  return (
    <div className="dpstextbox-component">
      {' '}
      <MWLTextBox
        size={size}
        label={label}
        onchangeHandler={textfieldChangeHandler}
        className={className}
        placeholder={placeholder}
        maxRows={maxRows}
        maxLength={maxLength}
        multiline={multiline}
        rows={rows}
        type={type}
        value={value}
        fieldName={fieldName}
        condition={condition}
        readOnly={readOnly}
        onFocus={onFocus}
        onBlur={handleBlur}
        error={error}
        errorText={errorText}
        disabled={disabled}
        startAdornmentIcon={startAdornmentIcon}
        allowCopyPaste={true}
      />
    </div>
  )
}

export default DpsTextBox
